import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from "react-router-dom";
import ReactDOMServer from 'react-dom/server';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import classnames from 'classnames';
import {Map} from "immutable";
import {Icon, ProgressBar} from "@blueprintjs/core";
import Modal from "@atlaskit/modal-dialog/dist/esm/components/Modal";

// Components
import SalesOrderDetail from "./SalesOrderDetail";
import SalesOrderIssues from "./SalesOrderIssues";
import SalesOrderInvoices from "./SalesOrderInvoices";
import SalesOrderFiles from './SalesOrderFiles';
import DeleteDialog from '../../../components/dialogs/DeleteDialog';
import SalesOrderPrint from "../../../components/common/SalesOrderPrint";

// Actions
import {
    getSalesOrder,
    updateSalesOrder,
    changeSalesOrderStatus,
    uploadSalesOrderFiles,
    downloadSalesOrderFile,
    deleteSalesOrderFile,
    deleteSalesOrder,
    cleanSalesOrders
} from "../../../actions/sales-orders";
import {addNotification} from "../../../actions/notifications";
import {downloadPdf} from "../../../actions/content";

class SalesOrderTabs extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tabIndex: this.getSelectedIndex(),
            editMode: false,
            canSubmit: false,
            status: '',
            // modal
            modalIsOpen: false,
            modalType: null
        };

        this.getSelectedIndex = this.getSelectedIndex.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
    }
    componentDidMount() {
        this.props.getSalesOrder(this.props.match.params.salesOrderId);
    }
    componentWillUnmount() {
        this.props.cleanSalesOrders();
    }

    // Tab handlers
    getSelectedIndex() {
        const {salesOrderId} = this.props.match.params;

        // Check if any child route is active. As last step, check if principal route is active to assign default tab index.
        switch (this.props.history.location.pathname) {
            case '/ventas/pedidos/' + salesOrderId + '/detalle':
                return 0;
            case '/ventas/pedidos/' + salesOrderId + '/albaranes':
                return 1;
            case '/ventas/pedidos/' + salesOrderId + '/facturas':
                return 2;
            case '/ventas/pedidos/' + salesOrderId + '/ficheros':
                return 3;
            default:
                return 0;
        }
    }
    handleTabChange(index, lastIndex, event) {
        const {salesOrderId} = this.props.match.params;
        let route = '';

        switch (index) {
            case 0:
                route = '/ventas/pedidos/' + salesOrderId + '/detalle';
                break;
            case 1:
                route = '/ventas/pedidos/' + salesOrderId + '/albaranes';
                break;
            case 2:
                route = '/ventas/pedidos/' + salesOrderId + '/facturas';
                break;
            case 3:
                route = '/ventas/pedidos/' + salesOrderId + '/ficheros';
                break;
            default:
                break;
        }

        this.props.history.push(route);
        this.setState({
            tabIndex: this.getSelectedIndex()
        });
    }

    // SalesOrderDetail handlers
    handleEditClick = () => {
        this.setState({
            editMode: true
        });
    };
    handleCancelClick = () => {
        this.child.updateSalesOrderState();
        this.setState({
            editMode: false,
            canSubmit: false
        });
    };
    handleSaveClick = () => {
        this.child.updateSalesOrder();
        this.setState({
            editMode: false
        });
    };
    canSubmit = (canSubmit) => {
        this.setState({ canSubmit })
    };

    // Print PDF
    printPdf = () => {
        const htmlHeader = ReactDOMServer.renderToStaticMarkup(<div></div>);
        const generateStaticMarkup = ReactDOMServer.renderToStaticMarkup(
            <SalesOrderPrint
                salesOrder={this.props.salesOrder}
            />
        );
        const htmlFooter = ReactDOMServer.renderToStaticMarkup(
            <div style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            }}>
                <div style={{ alignSelf: 'flex-end', fontSize: 12, marginRight: '30px' }}>
                    - <span className="pageNumber"></span> -
                </div>
                <div style={{ fontSize: 6 }} >INSCRITA EN EL REGISTRO MERCANTIL DE MURCIA, TOMO MU-3142, FOLIO 112, HOJA MU-87833</div>
            </div>
        );

        this.props.downloadPdf(generateStaticMarkup, {
            title: this.props.salesOrder.get('order_code') + '.pdf',
            printBackground: true,
            displayHeaderFooter: true,
            headerTemplate: htmlHeader,
            footerTemplate: htmlFooter,
            margin: {
                top: '50px',
                right: '50px',
                left: '50px',
                bottom: '150px'
            }
        });
    };

    // Modal handlers
    openModal = (modalType) => {
        this.setState({
            modalType,
            modalIsOpen: true
        });
    };
    closeModal = () => {
        this.setState({
            modalType: null,
            modalIsOpen: false
        })
    };

    render() {
        const { tabIndex, editMode, canSubmit } = this.state;

        const canNewIssue = ['partial', 'sent'].includes(this.props.salesOrder.get('status'));
        const canNewInvoice = ['sent'].includes(this.props.salesOrder.get('status'));

        // Modal Area
        let modal = null;
        if (this.state.modalIsOpen) {
            switch (this.state.modalType) {
                case 'deleteDialog':
                    modal = {
                        width: 'medium',
                        title: 'Borrar pedido de venta',
                        body: (
                            <DeleteDialog
                                text={ this.props.salesOrder.get('order_code') }
                            />
                        ),
                        footer: (
                            <div className="modal-footer">
                                <button
                                    key="cancel"
                                    type="button"
                                    className="btn btn-cancel"
                                    label={'Cancelar'}
                                    style={{
                                        color: 'gray',
                                        marginRight: 15
                                    }}
                                    onClick={this.closeModal}
                                >
                                    {'Cancelar'}
                                </button>
                                <button
                                    key="delete"
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={ () => {
                                        this.props.deleteSalesOrder(this.props.salesOrder.get('_id'));
                                        this.closeModal();
                                        this.props.history.push('/ventas/pedidos');
                                    }}
                                >
                                    {'Borrar'}
                                </button>
                            </div>
                        )
                    };
                    break;
                default:
                    modal = {
                        title: '',
                        body: null,
                        footer: null
                    };
                    break;
            }
        }

        return (

            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/ventas/resumen">Ventas</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/ventas/pedidos">Pedidos</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                <strong>{ this.props.salesOrder.get('order_code') }</strong>
                            </li>
                        </ol>
                    </div>
                    { this.props.uploadProgress.get('isUploading')
                        ? <div className="col d-flex align-items-center justify-content-end">
                            <ProgressBar
                                intent="PRIMARY"
                                value={ this.props.uploadProgress.get('percent') } />
                        </div>
                        : null
                    }
                    { tabIndex === 0
                        ? (
                            <div className="col d-flex align-items-center justify-content-end">
                                {!editMode
                                    ? <div className="title-action">
                                        <button
                                            className="btn btn-custom"
                                            onClick={ this.printPdf }
                                        ><Icon icon="print"/>Imprimir</button>
                                        { canNewIssue
                                            ? <button
                                                className="btn btn-primary"
                                                onClick={ () => {
                                                    this.props.history.push('/ventas/albaranes/nuevo', {
                                                        salesOrder: this.props.salesOrder
                                                    });
                                                }}
                                            >
                                                <Icon icon="insert"/>Albaran
                                            </button>
                                            : null
                                        }
                                        { canNewInvoice
                                            ? <button
                                                className="btn btn-primary"
                                                onClick={ () => {
                                                    this.props.history.push('/ventas/facturas/nuevo', {
                                                        salesOrder: this.props.salesOrder
                                                    });
                                                }}
                                            >
                                                <Icon icon="insert"/>Factura
                                            </button>
                                            : null
                                        }
                                        { this.props.salesOrder.get('can_delete')
                                                ? <button
                                                    className="btn btn-danger"
                                                    onClick={ () => this.openModal('deleteDialog') }
                                                >Borrar</button>
                                                : null
                                        }
                                        <button className="btn btn-custom" onClick={this.handleEditClick}>Editar</button>
                                    </div>
                                    : <div className="title-action">
                                        <button className="btn btn-cancel" onClick={this.handleCancelClick}>Cancelar</button>
                                        <button
                                            className="btn btn-primary"
                                            onClick={this.handleSaveClick}
                                            disabled={!canSubmit}
                                        >Guardar
                                        </button>
                                    </div>
                                }
                            </div>
                        ) : ''
                    }
                </div>
                <div className="wrapper wrapper-content">
                    <div className="row">
                        <div className="col">
                            <div className="tabs-container">
                                { this.props.salesOrder.get('_id')
                                    ? (
                                <Tabs
                                    selectedIndex={tabIndex}
                                    onSelect={this.handleTabChange}
                                    selectedTabPanelClassName="active show"
                                >
                                    <TabList className="nav nav-tabs">
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 0})}>Detalle</Link>
                                        </Tab>
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 1})}>Albaranes</Link>
                                        </Tab>
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 2})}>Facturas</Link>
                                        </Tab>
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 3})}>Ficheros</Link>
                                        </Tab>
                                    </TabList>
                                    <div className="tab-content">
                                        <TabPanel className="tab-pane">
                                            <SalesOrderDetail
                                                onRef={ref => (this.child = ref)}
                                                editMode={this.state.editMode}
                                                canSubmit={this.canSubmit}
                                                salesOrder={this.props.salesOrder}
                                                updateSalesOrder={this.props.updateSalesOrder}
                                                changeSalesOrderStatus={this.props.changeSalesOrderStatus}
                                            />
                                        </TabPanel>
                                        <TabPanel className="tab-pane">
                                            <SalesOrderIssues
                                                salesOrder={this.props.salesOrder}
                                                canNewIssue={canNewIssue}
                                                history={this.props.history}
                                            />
                                        </TabPanel>
                                        <TabPanel className="tab-pane">
                                            <SalesOrderInvoices
                                                salesOrder={this.props.salesOrder}
                                                canNewInvoice={canNewInvoice}
                                                history={this.props.history}
                                            />
                                        </TabPanel>
                                        <TabPanel className="tab-pane">
                                            <SalesOrderFiles
                                                salesOrder={this.props.salesOrder}
                                                uploadSalesOrderFiles={this.props.uploadSalesOrderFiles}
                                                uploadProgress={this.props.uploadProgress}
                                                downloadSalesOrderFile={this.props.downloadSalesOrderFile}
                                                deleteSalesOrderFile={this.props.deleteSalesOrderFile}
                                                addNotification={this.props.addNotification}
                                            />
                                        </TabPanel>
                                    </div>
                                </Tabs>
                                        )
                                        : null
                                    }
                            </div>
                        </div>
                    </div>
                </div>
                { this.state.modalIsOpen && (
                    <Modal
                        width={modal.width}
                        heading={modal.title}
                        footer={() => modal.footer}
                        autoFocus={false}
                        onClose={this.closeModal}
                    >
                        {modal.body}
                    </Modal>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    // Reducers
    const salesOrderReducer = state.salesOrders;

    // SalesOrder
    let salesOrder = salesOrderReducer.get('payload') || Map({});

    if (!(salesOrder instanceof Map)) {
        salesOrder = Map({})
    }

    // Upload Progress
    const uploadProgress = Map({
        isUploading: salesOrderReducer.get('isUploading') || false,
        percent: salesOrderReducer.get('percent') || 0
    });

    return {
        salesOrder,
        uploadProgress
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSalesOrder: (salesOrderId) => dispatch(getSalesOrder(salesOrderId)),
        updateSalesOrder: (salesOrderId, salesOrder) => dispatch(updateSalesOrder(salesOrderId, salesOrder)),
        changeSalesOrderStatus: (salesOrderId, status) => dispatch(changeSalesOrderStatus(salesOrderId, status)),
        uploadSalesOrderFiles: (salesOrderId, files) => dispatch(uploadSalesOrderFiles(salesOrderId, files)),
        downloadSalesOrderFile: (salesOrderId, fileId) => dispatch(downloadSalesOrderFile(salesOrderId, fileId)),
        deleteSalesOrderFile: (salesOrderId, fileId) => dispatch(deleteSalesOrderFile(salesOrderId, fileId)),
        deleteSalesOrder: (salesOrderId) => dispatch(deleteSalesOrder(salesOrderId)),
        cleanSalesOrders: () => dispatch(cleanSalesOrders()),
        addNotification: (notification) => dispatch(addNotification(notification)),
        downloadPdf: (htmlString, pdfOptions) => dispatch(downloadPdf(htmlString, pdfOptions))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SalesOrderTabs);



// WEBPACK FOOTER //
// ./src/containers/sales/orders/SalesOrderTabs.js